<template>
  <v-layout row
            wrap>
    <v-flex xs12>
      <v-breadcrumbs>
        <v-breadcrumbs-item>
          <v-icon left>home</v-icon>
        </v-breadcrumbs-item>
        <v-breadcrumbs-item>Dashboard</v-breadcrumbs-item>
        <v-breadcrumbs-item v-if="$auth.user().client">{{$auth.user().client.name}}</v-breadcrumbs-item>
      </v-breadcrumbs>
      <admin-dashboard v-if="(isAdmin() || isOperations())"/>
      <supplier-dashboard v-else-if="isSupplier()"/>
      <client-dashboard v-else-if="isClientAdmin() || isPurchasingHead() || isDepartmentHead() || isDepartmentUser()"/>
    </v-flex>
  </v-layout>
</template>

<script>
  import Base from './Base.vue'
  import ClientDashboard from './ClientDashboard'
  import SupplierDashboard from './SupplierDashboard'
  import AdminDashboard from './AdminDashboard'

  export default {
    name: 'dashboard',
    components: {
      AdminDashboard,
      SupplierDashboard,
      ClientDashboard
    },
    extends: Base

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue